<template>
  <div class="animated fadeIn pt-1">
    <b-row>
      <b-col md="7">
        <h4>Order Management</h4>
      </b-col>
      <b-col md="2">
        <eb-select
          type="select"
          style="font-size: 12px; font-weight: 600"
          v-model="selectStatusOption"
          :options="statusOptions"
          label="text"
          :id="'selecttime'"
          :placeholder="'Status'"
          @input="onStatusChange"
          :selected="selectStatusOption"
        ></eb-select>
      </b-col>
      <b-col md="2">
        <eb-select
          type="select"
          style="font-size: 12px; font-weight: 600"
          v-model="selectedDurationOption"
          :options="durationOptions"
          label="text"
          :id="'selectduration'"
          :placeholder="'Time Duration'"
          :selected="selectedDurationOption.text"
          @input="changeDuration"
        ></eb-select>
        <b-modal
          title="Select Date"
          header-class="header-nipige-class"
          id="dateRange"
          size="sm"
          ref="date-range"
          centered
          hide-footer
        >
          <b-input class="mb-2" type="date" v-model="startDate"></b-input>
          <b-input type="date" v-model="endDate"></b-input>
          <div class="text-center mt-2">
            <b-button
              @click="findButtonClick()"
              class="my -0 main-navigation-button w-47 mr-2"
              variant="success"
              >Find
            </b-button>
          </div>
        </b-modal>
      </b-col>
      <b-col md="1">
        <b-button size="sm" variant="success" @click="reloadData" :disabled="isLoading">
          <span v-if="isLoading" class="fa fa-refresh fa-spin" style="font-size: 15px" />
          <span v-else class="fa fa-refresh" style="font-size: 15px" />
        </b-button>
      </b-col>
    </b-row>
    <b-row class="mt-0">
      <b-col class="mt-0">
        <b-card border-variant="info" style="border-radius: 8px">
          <b-row class="mt-3">
            <b-col>
              <b-row>
                <b-col md="2" class="text-center">
                  <h5>Advance Filter</h5>
                </b-col>
                <b-col md="2" class="pr-2">
                  <eb-select
                    type="select"
                    style="font-size: 12px; font-weight: 600"
                    v-model="selectedSellerOption"
                    :options="sellerOptions"
                    label="text"
                    :id="'selectseller'"
                    :placeholder="'Seller'"
                    @input="onSellerChange"
                    :selected="selectedSellerOption"
                  ></eb-select>
                </b-col>
                <b-col md="2" class="pl-0 pr-0">
                  <eb-select
                    type="select"
                    style="width: 200px; font-size: 12px; font-weight: 600"
                    v-model="selectedSearchOption"
                    :options="searchOptionsData"
                    label="text"
                    :id="'searchby'"
                    placeholder="Select Search Criteria"
                    :selected="selectedSearchOption"
                    @input="onSearchChange"
                  ></eb-select>
                </b-col>
                <b-col md="4" class="pl-4">
                  <div v-if="this.show">
                    <b-form-input
                      class="searchField mr-sm-2"
                      style="font-size: 12px; font-weight: 600"
                      :placeholder="`${
                        this.show ? this.selectedSearchOption.text : 'Enter Order #'
                      }`"
                      v-model="searchQuery"
                      @keyup.enter="getOrderList"
                    ></b-form-input>
                    <eb-button
                      style="margin-top: -12px"
                      class="searchIcon"
                      classic="btn-light"
                      text=""
                      icon="fa fa-search"
                      iconSide="right"
                      :disabled="searchQuery == ''"
                      @click="getOrderList"
                    ></eb-button>
                  </div>
                </b-col>
                <b-col md="2" class="text-center">
                  <u>
                    <h4 style="color: blue; cursor: pointer" @click="resetFilter">
                      Reset Filter
                    </h4>
                  </u>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <hr />
          <b-table
            :dark="dark"
            :hover="hover"
            :striped="striped"
            :bordered="bordered"
            :small="small"
            :fixed="fixed"
            responsive
            :items="orderList"
            :fields="captions"
            :per-page="perPage"
            :filter="filter"
            thead-class="header"
            show-empty
            class="mt-3"
            :no-border-collapse="true"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
          >
            <template slot="empty">
              <div v-if="disableSellerKey" class="text-center">
                <span><b>Loading...</b></span>
              </div>
              <div v-else class="text-center">No data available.</div>
            </template>

            <template slot="customerPhone" slot-scope="data">
              {{
                getDeliveryContact(
                  (data &&
                    data.item &&
                    data.item.deliveryAddress &&
                    data.item.deliveryAddress.address &&
                    data.item.deliveryAddress.address.contacts) ||
                    ""
                )
              }}
            </template>

            <template slot="action" slot-scope="data">
              <b-button
                size="sm"
                class="mr-2"
                variant="primary"
                @click="
                  $router.push({
                    name: 'OrderDetail',
                    params: { id: data.item._id },
                  })
                "
              >
                <i class="fa fa-eye"></i>
              </b-button>
            </template>
            <template slot="createdAt" slot-scope="data">
              <div>{{ data.item.createdAt | formatedate }}</div>
            </template>
          </b-table>
          <div style="float: right; padding: 20px 0px">
            <b-pagination
              v-model="currentPage"
              :per-page="perPage"
              :total-rows="totalRows"
              aria-controls="my-table"
              prev-text="Prev"
              next-text="Next"
              @change="paginationClick"
              hide-goto-end-buttons
            ></b-pagination>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import VueSimpleSuggest from "vue-simple-suggest";
import ebButton from "@/components/FormElements/Button";
import ebSelect from "@/components/FormElements/Select.vue";
import moment from "moment";
import currentUserData from "@/mixins/currentUser";
export default {
  mixins: [currentUserData],
  name: "manageOrder",
  components: {
    ebButton,
    ebSelect,
    VueSimpleSuggest,
  },
  data: () => {
    return {
      show: false,
      isLoading: false,
      searchInput: "",
      startDate: "",
      fromDate: moment().format("YYYY-MM-DD"),
      disableSellerKey: false,
      endDate: "",
      toDate: moment().format("YYYY-MM-DD"),
      timeRange: "",
      allSellerOptions: [],
      sortBy: "createdAt",
      sortDesc: true,
      selectedDurationOption: {
        text: "Today",
        value: 1,
      },
      durationOptions: [
        {
          text: "Today",
          value: 1,
        },
        {
          text: "7 Days",
          value: 7,
        },
        {
          text: "30 days",
          value: 30,
        },
        {
          text: "Custom",
          value: "custom",
        },
      ],
      searchSellerBy: {
        text: "By Name",
        value: "name",
      },
      searchListOptions: [
        {
          text: "By Name",
          value: "name",
        },
        {
          text: "By Email",
          value: "email",
        },
        {
          text: "By Phone",
          value: "phone",
        },
      ],
      selectedSearchOption: { text: "Search Criteria", value: "" },
      searchOptions: [
        {
          text: "Order Number",
          value: "orderId",
        },
        {
          text: "Seller Name",
          value: "providerName",
        },
        {
          text: "Seller Phone Number",
          value: "providerPhone",
        },
        {
          text: "Seller Email",
          value: "providerEmail",
        },
        {
          text: "Customer Name",
          value: "customerName",
        },
        {
          text: "Customer Phone Number",
          value: "customerPhone",
        },
        {
          text: "Customer Email",
          value: "customerEmail",
        },
      ],
      selectStatusOption: {
        text: "Order Status (All)",
        value: "",
      },
      statusOptions: [
        {
          text: "All",
          value: "",
        },
        {
          text: "Confirmed",
          value: "Confirmed",
        },
        {
          text: "Processing",
          value: "Processing",
        },
        {
          text: "Delivered",
          value: "Delivered",
        },
        {
          text: "Created",
          value: "Created",
        },
        {
          text: "Out For Delivery",
          value: "Out For Delivery",
        },
        {
          text: "Payment Failed",
          value: "Payment Failed",
        },
        {
          text: "Cancelled",
          value: "Cancelled",
        },
        {
          text: "Rejected",
          value: "Rejected",
        },
        {
          text: "Returned",
          value: "Returned",
        },
        {
          text: "Dispatched",
          value: "Dispatched",
        },
        {
          text: "Refund",
          value: "Refund",
        },
        {
          text: "Delivery Attached",
          value: "Delivery Attached",
        },
      ],
      selectedSellerOption: { text: "All Sellers", value: "all" },
      searchQuery: "",
      showDismissibleAlert: false,
      loading: false,
      items: [],
      tableFields: [
        {
          key: "orderId",
          label: "Order#",
          sortable: true,
        },
        {
          key: "createdAt",
          label: "Order Date",
          sortable: true,
        },
        {
          key: "deliveryAddress.address.fullName",
          label: "Customer Name",
          sortable: false,
        },
        {
          key: "customerPhone",
          label: "Customer Phone",
          sortable: false,
        },
        {
          key: "orderStatus",
          label: "Status",
          sortable: false,
        },
        {
          key: "orderAmount",
          label: "Amount",
          sortable: true,
        },
        {
          key: "deliveryCharges",
          label: "Delivery Charges",
          sortable: true,
        },
        {
          key: "action",
          label: "Action",
        },
      ],
      filter: "",
      caption: "Table",
      hover: true,
      striped: false,
      bordered: true,
      small: false,
      fixed: false,
      tableData: [],
      perPage: 10,
      totalRows: 100,
      currentPage: 1,
      dark: false,
    };
  },
  methods: {
    getDeliveryContact(data) {
      let phoneList = [];
      if (Array.isArray(data) && data.length > 0) {
        data.forEach((obj) => {
          if (obj.contactType == "PRIMARY_PHONE") {
            phoneList.push(obj.value);
          }
        });
        return phoneList.toString();
      } else {
        ("");
      }
    },
    async paginationClick(e) {
      this.currentPage = e;
      await this.getOrderList();
    },
    async onStatusChange(e) {
      this.selectStatusOption = e;
      this.currentPage = 1;
      this.totalRows = 1;
      await this.getOrderList();
    },
    onSearchChange() {
      this.show = true;
      if (this.searchQuery != "") {
        this.searchQuery = "";
      }
    },
    async onSellerChange(data) {
      this.selectedSellerOption = data;
      this.currentPage = 1;
      this.totalRows = 1;
      this.disableSellerKey = true;
      await this.getOrderList();
      this.disableSellerKey = false;
    },

    async searchSpecificSeller(sellerData) {
      if (sellerData && sellerData.length >= 3) {
        this.currentPage = 1;
        this.totalRows = 1;
        this.$store.dispatch("order/cleanOrderList");
        let payload = {
          type: "SELLER",
          key: this.searchSellerBy.value,
          keyVal: this.searchInput,
          includeHierarchy: "y",
        };
        await this.$store.dispatch("partner/listPartnerSearchByNameEmailPhone", payload);
      }
    },
    async findButtonClick() {
      this.fromDate = this.startDate;
      this.toDate = this.endDate;
      this.timeRange = "";

      this.$refs["date-range"].hide();
      await this.getOrderList();
    },
    async changeDuration() {
      //   sessionStorage.setItem(
      //     "resultDuration",
      //     JSON.stringify({
      //       text: this.selectedDurationOption.text,
      //       value: this.selectedDurationOption.value,
      //     })
      //   );
      let e = this.selectedDurationOption;
      if (e.value == "custom") {
        this.$refs["date-range"].show();
        return;
      } else {
        this.fromDate = moment()
          .subtract(e.value - 1, "days")
          .format("YYYY-MM-DD");
        this.toDate = moment().format("YYYY-MM-DD");
      }
      await this.getOrderList();
    },
    async getOrderList() {
      this.loading = true;
      this.$store.dispatch("order/cleanOrderList");
      this.disableSellerKey = true;
      let payload = {
        provider: this.selectedSellerOption.value,
        orderStatus: this.selectStatusOption.value,
        fromDate: this.fromDate,
        toDate: this.toDate,
      };
      if (this.selectedSearchOption.value.length > 0) {
        payload.type = this.selectedSearchOption.value;
        payload.typeVal = this.searchQuery;
        payload.fromDate = "2022-08-15";
        payload.toDate = this.toDate;
      }
      payload.limit = 10;
      payload.page = this.currentPage;
      await this.$store
        .dispatch("order/listOrderForAllUsers", payload)
        .then((res) => {
          this.totalRows = res.meta.total > 0 ? res.meta.total : 1;
        })
        .catch((err) => {
          this.isLoading = false;
        });

      this.disableSellerKey = false;
      this.isLoading = false;
    },
    async reloadData() {
      this.isLoading = true;
      await this.getOrderList();
      this.isLoading = false;
    },
    resetFilter() {
      this.isLoading = true;
      this.selectedSellerOption = { text: "All Sellers", value: "" };
      this.selectedSearchOption = { text: "Search Criteria", value: "" };
      this.searchQuery = "";
      this.getOrderList();
      this.isLoading = false;
    },
  },
  created() {
    this.timeRange = 1;
  },
  mounted: async function () {
    // this.selectedDurationOption = JSON.parse(
    //   sessionStorage.getItem("resultDuration")
    // );
    await this.getOrderList();
    await this.changeDuration();
  },
  computed: {
    sellerOptions() {
      if (this.$currentUserData.category == "SELLER") {
        return [
          {
            text: "All Seller",
            value: "all",
          },
          {
            text: "Direct Sellers",
            value: "direct",
          },
        ];
      } else {
        return [
          {
            text: "All Seller",
            value: "all",
          },
          {
            text: "Direct Sellers",
            value: "direct",
          },
          {
            text: "Include Hierarchy",
            value: "all",
          },
        ];
      }
    },
    searchOptionsData() {
      if (this.$currentUserData.category == "SELLER") {
        if (this.selectedSellerOption.value == "direct") {
          return (this.searchOptions = [
            {
              text: "Order Number",
              value: "orderId",
            },
            {
              text: "Customer Name",
              value: "customerName",
            },
            {
              text: "Customer Phone Number",
              value: "customerPhone",
            },
            {
              text: "Customer Email",
              value: "customerEmail",
            },
          ]);
        } else {
          return (this.searchOptions = [
            {
              text: "Order Number",
              value: "orderId",
            },
            {
              text: "Seller Name",
              value: "sellerName",
            },
            {
              text: "Seller Phone Number",
              value: "sellerPhone",
            },
            {
              text: "Seller Email",
              value: "sellerEmail",
            },
            {
              text: "Customer Name",
              value: "customerName",
            },
            {
              text: "Customer Phone Number",
              value: "customerPhone",
            },
            {
              text: "Customer Email",
              value: "customerEmail",
            },
          ]);
        }
      } else {
        return this.searchOptions;
      }
    },
    captions() {
      let tableField = this.tableFields;
      tableField.splice(
        3,
        0,
        this.userCategory === "TA" ||
          this.userCategory === "SELLER" ||
          this.userCategory === "DISTRIBUTOR" ||
          this.userCategory === "DEALER" ||
          this.userCategory === "OFFICE"
          ? {
              key: "items[0].providerName",
              label: "Seller Name",
              sortable: false,
            }
          : {
              key: "provider.organization.name",
              label: "Seller Name",
              sortable: false,
            }
      );
      return tableField;
    },
    orderList() {
      let currentUser = JSON.parse(sessionStorage.getItem("userLogin"));
      let listData = [];
      if (currentUser.role === "Tenant") {
        let list = this.$store.getters["order/GetListOrderAllUsers"];
        let regex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
        if (list.length > 0) {
          list.forEach((itemList) => {
            if (
              itemList.customerId &&
              itemList.customerId.authentication &&
              itemList.customerId.authentication.phone
            ) {
              itemList.customerId.authentication.phone = regex.test(
                itemList.customerId.authentication.phone
              )
                ? null
                : itemList.customerId.authentication.phone;
            }
            if (itemList.isMaster) {
              listData.push(itemList);
            }
          });
        }
        this.loading = false;
        return listData.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      } else if (currentUser.role === "Partner") {
        let list = [];
        if (this.userCategory === "MANUFACTURER") {
          list = this.$store.getters["order/GetListOrderAllUsers"];
        } else {
          list = this.$store.getters["order/GetListOrderAllUsers"];
        }
        //code changed for email and phone number field clashes in Partner
        let regex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
        if (list.length > 0) {
          list.forEach((itemList) => {
            if (
              itemList.customerId &&
              itemList.customerId.authentication &&
              itemList.customerId.authentication.phone
            ) {
              itemList.customerId.authentication.phone = regex.test(
                itemList.customerId.authentication.phone
              )
                ? null
                : itemList.customerId.authentication.phone;
            }
            if (itemList.isMaster) {
              listData.push(itemList);
            }
          });
        }
        this.loading = false;
        return listData.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      }
    },
    userCategory() {
      return JSON.parse(sessionStorage.getItem("userLogin"))["category"];
    },
  },
  filters: {
    formatedate: function (value) {
      if (value) {
        return moment(String(value)).format("DD-MMM-YYYY hh:mm A");
      }
    },
  },
};
</script>
<style>
.edit {
  color: #ffffff !important;
}

.bin {
  color: white !important;
}

.custom-control-label::after {
  position: absolute;
  top: 0.15625rem;
  left: -1.5rem;
  display: block;
  width: 1.4rem;
  height: 1.4rem;
  content: "";
  background: no-repeat 50%/50% 50%;
}

.custom-control-label::before {
  position: absolute;
  top: 0.15625rem;
  left: -1.5rem;
  display: block;
  width: 1.4rem;
  height: 1.4rem;
  pointer-events: none;
  content: "";
  background-color: #fff;
  border: #000000 solid 2px;
}

.delivery-radio-align {
  margin-left: 11px;
  font-size: 15px;
}

.searchField {
  font-size: 12px;
  font-weight: 600;
  border-radius: 17px;
  padding: 17px;
  height: 36px;
}

.searchIcon {
  height: 36px;
  width: 36px;
  position: absolute;
  top: 12px;
  right: 15px;
  z-index: 10;
  border-radius: 30px;
}

.suggestions {
  position: absolute;
  width: 86%;
  z-index: 2;
  border: 1px solid #cbd3d7;
  border-radius: 4px;
  background-color: #ffffff;
  list-style: none;
  padding: 5px 0px;
  margin: 0px;
  margin-top: 1px;
}

.vue-simple-suggest.designed .input-wrapper input {
  padding-left: 16px;
  background-color: #ffffff;
  border: 1px solid #cbd3d7;
  border-radius: 25px !important;
  height: 36px;
}

.suggest-item {
  padding: 4px 15px;
}

.hover {
  cursor: pointer;
  background-color: #5897fb;
  color: #fff;
}

:focus-visible {
  outline: none;
}
</style>
